import { Link } from "gatsby"
import React from "react"

export default () => {
    return <div className="text-center">
        <p className="text-7xl mb-5 font-bold">入此网站者<br/>当断绝一切希望。</p>
    </div>
}